var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Dialog",
    _vm._b(
      {
        attrs: {
          "custom-class": "dialog-component-main",
          "close-on-click-modal": _vm.closeOnClickModal,
          "show-close": false,
          "close-on-press-escape": false,
          visible: _vm.dialogValue,
          center: "",
          width: _vm.width,
        },
        on: {
          "update:visible": function ($event) {
            _vm.dialogValue = $event
          },
        },
      },
      "Dialog",
      _vm.$attrs,
      false
    ),
    [
      _c("div", { staticClass: "dialog-component-container flex-column" }, [
        _vm.title
          ? _c(
              "div",
              { staticClass: "dialog-header-container flex-center-center" },
              [
                _c("p", [_vm._v(_vm._s(_vm.title))]),
                _c(
                  "div",
                  { staticClass: "dialog-close-container" },
                  [
                    _vm._t("titleRight"),
                    _vm.showClose
                      ? _c("i", {
                          staticClass: "el-icon-close",
                          on: { click: _vm.handleClose },
                        })
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "flex-content-scroll", style: _vm.bodyStyle },
          [_vm._t("default")],
          2
        ),
        _vm.$slots.footer
          ? _c(
              "div",
              { staticClass: "dialog-footer-container flex-center-center" },
              [_vm._t("footer")],
              2
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }